<astrobin-drag-drop-area
  [attr.id]="field.id"
  [multipleFiles]="uploadOptions?.multiple"
  (filesDrop)="handleFilesDrop($event)"
>
  <div class="chunked-file">
    <label [class.active]="isActive()" class="upload-btn">
      <div *ngIf="uploadState?.progress" [style.width.%]="uploadState.progress" class="progress-area">
        <span class="background"></span>
      </div>

      <span class="file">
        <ng-container *ngIf="upload && upload.name; else withoutFile">
          {{ upload.name }} ({{ uploadSize | filesize }})

          <ng-container
            *ngIf="
              field.props.additionalInfoTemplate && (uploadState.status === 'added' || uploadState.status === 'queue')
            "
          >
            <div class="additional-info">
              <ng-container *ngTemplateOutlet="field.props.additionalInfoTemplate"></ng-container>
            </div>
          </ng-container>

          <span *ngIf="uploadState.status !== 'added' && uploadState.status !== 'queue'" class="status">
            {{ statusWithProgress$ | async }}
          </span>
        </ng-container>

        <ng-template #withoutFile>
          <fa-icon icon="upload"></fa-icon>
          <div class="choose-file">{{ uploadLabel }}</div>
        </ng-template>
      </span>

      <input
        [formControl]="formControl"
        [formlyAttributes]="field"
        [uploadx]="uploadOptions"
        (state)="onStateChange($event)"
        class="chunked"
        type="file"
      />
    </label>
  </div>
</astrobin-drag-drop-area>
